module.exports = __webpack_public_path__ + "img/21-1.06c9ac5a.jpg";